//https://tg-front-locator.tg41.uk/form/kz,test,home

import React, { useState, useEffect, useCallback } from 'react';
import { useTelegram } from '../../hooks/useTelegram';
import { useParams } from 'react-router-dom';
import './Form.css';

const Form = () => {
    const params = useParams();
    const { tg } = useTelegram();

    const [tags, setTags] = useState('');
    const [description, setDescription] = useState('');
    const [activeBadges, setActiveBadges] = useState([]); // allow multiple badges
    const badges = params?.chat_names ? params.chat_names.split(/\s*,\s*/) : [];

    const handleBadgeClick = (index) => {
        const badge = badges[index];
        const currentTags = tags ? tags.split(/\s*,\s*/) : [];
        let newTags;

        if (currentTags.includes(badge)) {
            newTags = currentTags.filter(tag => tag !== badge);
        } else {
            newTags = [...currentTags, badge];
        }

        setTags(newTags.join(', '));
    };

    const onSendData = useCallback(() => {
        const data = { tags, description };
        tg.sendData(JSON.stringify(data));
    }, [tags, description, tg]);

    useEffect(() => {
        tg.onEvent('mainButtonClicked', onSendData);
        return () => {
            tg.offEvent('mainButtonClicked', onSendData);
        };
    }, [onSendData, tg]);

    useEffect(() => {
        tg.MainButton.setParams({ text: 'Send data' });
    }, [tg]);

    useEffect(() => {
        if (!tags || !description) {
            tg.MainButton.hide();
        } else {
            tg.MainButton.show();
        }
    }, [tags, description, tg]);

    const onChangeTags = (e) => {
        const cleaned = e.target.value.replace(/[^a-zA-Z0-9,\s]/g, '');
        setTags(cleaned);
    };

    const onChangeDescription = (e) => {
        setDescription(e.target.value);
    };

    return (
        <div className='form'>
            <h3>Input your data</h3>
            <input
                className='input'
                type='text'
                placeholder='tags'
                value={tags}
                onChange={onChangeTags}
            />
            <textarea
                className='input'
                rows='8'
                placeholder='description'
                value={description}
                onChange={onChangeDescription}
            />

            <div className='badge-container'>
                <div className='badge-container__deco'>
                    {badges.map((badge, index) => (
                        <div
                            key={index}
                            className={`badge ${tags.includes(badge) ? 'active' : ''}`}
                            onClick={() => handleBadgeClick(index)}
                        >
                            {badge}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default Form;

/* <textarea rows="3" cols="30" name="text" placeholder="Enter your text here..."></textarea> */